import React from 'react';
import capitalize from 'lodash/capitalize';

export const PricingEligibility = ({ plan }: { plan?: string | null }) => (
  <div>
    {plan ? (
      <>
        <label>Pricing eligibility</label>
        <div data-testid="plan">{capitalize(plan)}</div>
      </>
    ) : (
      'Commercial'
    )}
  </div>
);
